import { GAMEPLAY_CONFIG } from '../constants/GameplayConfig';
import { CONE_CLAMP_TOLERANCE } from '../logic/MeleeConeProfile';

/** Reach extensions retain authored larger flight budgets and current velocity. */
export const COMBAT_REACH_SCALE = 1.25;
export const MIN_PROJECTILE_REACH = 600;
export const PROJECTILE_FLIGHT_PADDING_MS = 200;
export function extendedAuthoredReach(value: number, projectile = false): number {
  if (!Number.isFinite(value) || value <= 0) return value;
  return Math.max(projectile ? MIN_PROJECTILE_REACH : 0, Math.ceil(value * COMBAT_REACH_SCALE));
}
export function projectileFlightBudget(range: number, speed: number, lifespan: number, homingDelay = 0): number {
  if (!Number.isFinite(range) || range <= 0 || !Number.isFinite(speed) || speed <= 0) return lifespan;
  return Math.max(lifespan, Math.ceil((range + 60) / speed * 1000 + homingDelay + PROJECTILE_FLIGHT_PADDING_MS));
}

/** Match the authoritative area envelope, including cones and the current line wire radius. */
export function legalAreaReach(value: number, canonical?: { radius?: number; coneRangePx?: number }): number {
  const cap = (distance?: number): number => distance !== undefined && distance > 0
    ? distance * CONE_CLAMP_TOLERANCE : Infinity;
  return Math.min(value, cap(canonical?.radius), cap(canonical?.coneRangePx), GAMEPLAY_CONFIG.antiCheat.maxAreaRadius);
}
